import { ISearchProps } from "../models/ISearchProps";
import { ISearchResult } from "../models/ISearchResult";
import HttpService from "../../../services/HttpService";

interface ISolrResponseDoc {
    id;
    path;
    title;
    description;
}

interface ISolrSearchResponse {
    docs: ISolrResponseDoc[];
    numFound: number;
    start: number;
}

interface ISolrHttpResponse {
    response: ISolrSearchResponse;
    responseHeaders: number;
}

function arrayToString(prop: string|string[]) {
    return Array.isArray(prop) ? prop.join('') : prop;
}

export async function solrSearch({ query, pageType, pageNumber, limit, category, tag }: ISearchProps): Promise<ISearchResult[]> {
    const results = await HttpService.get<ISolrHttpResponse>(process.env.GATSBY_SOLR_SEARCH_URL,
        null,
        {
            params: {
                q: query,
                pt: pageType,
                page: pageNumber,
                limit,
                cat: category,
                tag,
                clientCacheBypass: `${Math.floor(Date.now() / parseInt(process.env.SOLR_CACHE_INTERVAL_MS || '900001'))}`, // create a param to bypass the cache every 15 minutes
            }
        }
    );
    return results.response.docs.map(({id, title, path, description}) => ({
        key: id,
        title: arrayToString(title),
        path: arrayToString(path),
        description: arrayToString(description),
    }));
}
